export default __webpack_public_path__ + "static/media/news_item_placeholder.11b5de3e.png";